import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ActivityService } from 'src/app/core/services/activity.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-interview-details',
  templateUrl: './interview-details.component.html',
  styleUrls: ['./interview-details.component.scss'],
  standalone: false,
})
export class InterviewDetailsComponent implements OnInit {
  activeTableSource: MatTableDataSource<any>;
  expiredTableSource: MatTableDataSource<any>;
  columnDefs: string[];
  candidateId: any;
  activeSource: any;
  expiredSource: any;
  profileHistory: any;
  pfError: any;
  @Output() selectedAppId: EventEmitter<any> = new EventEmitter();
  applnStatusResp: any;

  constructor(
    private httpclient: HttpClient,
    private router: Router,
    private activityService: ActivityService,
    private profile: ProfileService,
    public dialogRef: MatDialogRef<InterviewDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.candidateId = this.data.candidateId;
    console.log(this.candidateId);
    if (this.data.popUp == 'interview') {
      this.columnDefs = [
        'Application ID',
        'Company Hiring Type',
        'Last Activity Status',
        'Reason',
        'Source Valid Till',
        'Mode of Interview',
        'Interview Date',
        'Tech Panel EmpID',
        'Tech Panel EmpName',
        'Tech HR EmpID',
        'Tech HR EmpName',
      ];
      this.activeTableSource = new MatTableDataSource(this.activeSource);
      this.expiredTableSource = new MatTableDataSource(this.expiredSource);
      this.getInterviewData();
    } else if (this.data.popUp == 'profile') {
      this.columnDefs = ['icon', 'File Name', 'Created on', 'Image'];
      this.getProfileHistory();
    } else if (this.data.popUp == 'applnStatus') {
      const data1 = {
        candidateId: this.candidateId,
        applicationId: this.data.applicationId,
      };
      this.activityService.applicationStatus(data1).subscribe((res) => {
        this.applnStatusResp = res;
      });
    }
  }

  getInterviewData() {
    if (this.candidateId) {
      this.activityService.getInterviewDetails(this.candidateId).subscribe(
        (res: any[]) => {
          if (res.length > 0) {
            const activeSourceArr = [];
            const expiredSourceArr = [];

            res.forEach((interviewData) => {
              const interviews = Array.isArray(interviewData.interviews)
                ? interviewData.interviews
                : [interviewData.interviews];

              const dataArr = [];

              if (interviews.length > 0) {
                interviews.forEach((interview, _index) => {
                  const data = {
                    'Application ID': interviewData.applicationId || '-',
                    'Company Hiring Type': interviewData.companyHiring || '-',
                    'Last Activity Status': interviewData.lastActivityStatus || '-',
                    Reason: interviewData.reason || '-',
                    'Source Valid Till': interviewData.sourceEndDate || '-',
                    'Mode of Interview': interview.modeOfInterview || '-',
                    'Interview Date': interview.interviewDate || '-',
                    'Tech Panel EmpID': interview.panelId ? interview.panelId.join(', ') : '-',
                    'Tech Panel EmpName': interview.panelName ? interview.panelName.join(', ') : '-',
                    'Tech HR EmpID': interview.hrId ? interview.hrId.join(', ') : '-',
                    'Tech HR EmpName': interview.hrName ? interview.hrName.join(', ') : '-',
                  };

                  if (interviewData.sourceFlag) {
                    expiredSourceArr.push(data);
                  } else {
                    activeSourceArr.push(data);
                  }

                  dataArr.push(data);
                });
              } else {
                const data = {
                  'Application ID': interviewData.applicationId || '-',
                  'Company Hiring Type': interviewData.companyHiring || '-',
                  'Last Activity Status': interviewData.lastActivityStatus || '-',
                  Reason: interviewData.reason || '-',
                  'Source Valid Till': interviewData.sourceEndDate || '-',
                  'Mode of Interview': '-',
                  'Interview Date': '-',
                  'Tech Panel EmpID': '-',
                  'Tech Panel EmpName': '-',
                  'Tech HR EmpID': '-',
                  'Tech HR EmpName': '-',
                };

                if (interviewData.sourceFlag) {
                  expiredSourceArr.push(data);
                } else {
                  activeSourceArr.push(data);
                }

                dataArr.push(data);
              }

              console.log('dataArr', dataArr);
            });
            this.activeSource = activeSourceArr;
            this.expiredSource = expiredSourceArr;

            this.activeTableSource = new MatTableDataSource(this.activeSource);
            this.expiredTableSource = new MatTableDataSource(this.expiredSource);
          } else {
            console.log('No interviews found.');
          }
        },
        (err) => {
          console.log('Error fetching interview data:', err);
        },
      );
    }
  }

  OnClose() {
    this.dialogRef.close();
  }
  redirect(applicationId) {
    this.dialogRef.close(applicationId);
  }

  getProfileHistory() {
    this.profile.getProfileHistory(this.candidateId).subscribe(
      (res) => {
        // console.log(res);
        if (res.length > 0) {
          const pfhstry = res;
          pfhstry.forEach((fileRes, index) => {
            const base64 = fileRes.file;
            pfhstry[index]['imgURL'] = 'data:image/' + fileRes.fileType.substr(1) + ';base64,' + base64;
          });
          const candPic = pfhstry.reverse();
          this.profileHistory = new MatTableDataSource(candPic);
          // console.log(this.profileHistory);
        } else {
          this.pfError = 'No Data Available';
        }
      },
      (_err) => {
        this.pfError = 'Something went wrong! Please try again!';
      },
    );
  }

  downloadProfilePic(row) {
    const base64 = row.file;
    const link = document.createElement('a');
    link.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + base64;
    link.download = row.fileName + row.fileType;
    link.click();
  }
}
